// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"store-notice_wrapper__YtE0X","point_notice":"store-notice_point_notice__Bvyb9","store_content":"store-notice_store_content__sxgLb"};